module.exports = __webpack_public_path__ + "img/MEDISCA-Logo.42df1a5e.png";